import { render, staticRenderFns } from "./TotalSalariesForOneDepartment.vue?vue&type=template&id=31a03eaa&"
import script from "./TotalSalariesForOneDepartment.vue?vue&type=script&lang=js&"
export * from "./TotalSalariesForOneDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a03eaa')) {
      api.createRecord('31a03eaa', component.options)
    } else {
      api.reload('31a03eaa', component.options)
    }
    module.hot.accept("./TotalSalariesForOneDepartment.vue?vue&type=template&id=31a03eaa&", function () {
      api.rerender('31a03eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/budget/TotalSalariesForOneDepartment.vue"
export default component.exports